import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  floatingContent: {
    transitionDuration: '80ms',
    transitionProperty: 'opacity, transform',
    transitionTimingFunction: 'ease-in-out',
    '&.hide': {
      transform: 'translateY(-8px)',
      opacity: '0',
    },
    '&.show': {
      transform: 'translateY(0)',
      opacity: '1',
    },
  },
});

export default useStyle;
